import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseHighlightModule } from '@fuse/components';
import { FuseWidgetModule } from '../fuse/components/widget/widget.module';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../common/shared.module';
import { AddTaskComponent } from './components/add-task/add-task.component';
import { AddTimeComponent } from './components/add-time/add-time.component';
import { AngularMaterialModule } from 'app/angular-material.module';
import { TaskSaveService } from './services/task-save.service';
import { EmployeeModule } from '../employee/employee.module';
import { TaskManagementComponent } from './components/task-management/task-management.component';

@NgModule({
    declarations: [
        AddTaskComponent,
        AddTimeComponent,
        TaskManagementComponent
    ],
    exports: [
        FuseSharedModule,
        FuseHighlightModule,
        FuseWidgetModule,
        TaskManagementComponent
    ],
    imports: [
        CommonModule,
        FuseSharedModule,
        FuseHighlightModule,
        FuseWidgetModule,
        RouterModule,
        AngularMaterialModule,
        SharedModule,
        EmployeeModule
    ],
    providers: [
        TaskSaveService
    ]
})
export class TaskModule {
}
